

exports.__esModule = true;
exports.$fallbackErrorHandler = $fallbackErrorHandler;

var _angular = require('angular');

var _uiRouter = require('uiRouter');

var _index = require('xo-return-to-merchant/dist/index');

var _squid = require('squid');

var _index2 = require('xo-models/src/user/index');

var _index3 = require('xo-models/src/checkout/index');

var _logger = require('xo-beaver/dist/logger');

function goToUrl(url, wpsParams, xoAppData) {
    if (xoAppData.is_wps_flow()) {
        return _index.$ReturnToMerchant.postTo(url, wpsParams);
    }

    return _index.$ReturnToMerchant.goTo(url);
}

/**
 * This function contains an additional determination of fallback url in case of an UX fallback
 *
 * @param {object} checkoutAppDataModel
 * @param {string} fallbackUrl
 * @returns {string}
 */
function determineUrlForUxFallback(checkoutAppDataModel, fallbackUrl) {
    var experienceInitiator = checkoutAppDataModel.get('flags.payment_experience_initiator');

    // For UX fallback during a PPPlus transaction the fallback url
    // is merchants cancel_url with added parameter ppp_msg = 1
    if (experienceInitiator === 'PAYPAL_PLUS') {
        return _squid.$util.buildURL(checkoutAppDataModel.get('urls.cancel_url'), { ppp_msg: '1' });
    }

    return fallbackUrl;
}

function goToGenericError() {
    var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'DEFAULT';

    _uiRouter.$state.go('checkout.genericError', { code: code });
    return true;
}

function $fallbackErrorHandler() {
    var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var reason = err.reason;

    var models = {};

    return (0, _squid.$populate)(models, {
        checkoutAppData: _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
        checkoutCart: _index3.$CheckoutCartModel.instance(_angular.$rootScope.token),
        checkoutInputData: _index2.$CheckoutInputDataModel.instance(_angular.$rootScope.token),
        payeeModel: _index3.$CheckoutPayeeModel.instance(_angular.$rootScope.token)
    }).then(function () {
        var checkoutAppData = models.checkoutAppData,
            checkoutCart = models.checkoutCart,
            checkoutInputData = models.checkoutInputData;


        if (checkoutCart.isWalletTokenization()) {
            return goToGenericError();
        }

        if (checkoutAppData.doec_on_approve() && _angular.$rootScope.paymentComplete) {
            // Do not fallback. UX has no context of hermes token and will result in duplicate payment
            _logger.$logger.info('wps_error_payment_already_done', { reason: reason });
            return goToGenericError('PAYMENT_ALREADY_DONE');
        }

        var _$config$fallbackWhit = _squid.$config.fallbackWhitelist;
        _$config$fallbackWhit = _$config$fallbackWhit === undefined ? {} : _$config$fallbackWhit;
        var _$config$fallbackWhit2 = _$config$fallbackWhit.whitelist,
            whitelist = _$config$fallbackWhit2 === undefined ? [] : _$config$fallbackWhit2;


        if (err instanceof _squid.$FallbackError) {
            var _err$product = err.product,
                product = _err$product === undefined ? 'ux' : _err$product;
            var entry_point = err.entry_point;


            if (checkoutInputData.requiresOAuth()) {
                // there is no fallback for flows that require oauth code return (ex:PROX Signup),
                // so we show a generic error page
                _logger.$logger.error('fallback_inhibited_for_oauth_return_flows', { reason: reason });
                return goToGenericError(reason);
            }

            if (product === 'ux' && _angular.$rootScope.partnerIntegration) {
                _logger.$logger.info('partner_integration_fallback_to_UX');
                _angular.$window.resizeTo(screen.availWidth, screen.availHeight);
            }

            // For checkout-order tokens symphony sets checkoutAppData.flags.disable_legacy_fallback flag to 'true'.
            // In such cases we disable fallback to UX and show the generic error page.
            if (checkoutAppData.get('flags.disable_legacy_fallback')) {
                _logger.$logger.error('fallback_inhibited_for_checkout_order_tokens', { reason: reason });
                return goToGenericError(reason);
            }

            _squid.$util.assert(reason, 'expected fallback reason');

            _logger.$logger.log(product ? 'info' : 'error', 'fallback', {
                reason: reason,
                product: product,
                entry_point: entry_point
            });

            var country = _squid.$locale.country;

            var paymentAction = checkoutCart.payment_action;

            _logger.$logger.info('fallback_reason_' + reason);
            if (checkoutAppData.is_wps_flow()) {
                _logger.$logger.log('info', 'wps_fallback', {
                    token: _squid.$meta.token,
                    reason: reason
                });
                _logger.$logger.info('wps_fallback_reason_' + reason, { reason: reason });
            }

            if (!_squid.$config.fallbackEnabled && !entry_point) {
                _logger.$logger.info('fallback_disabled_by_config');
                return goToGenericError();
            }

            /**
             * CONFIG BASED WHITELIST:
             * Determines if we should fallback or instead redirect to generic error page.
             * We go to generic error page if the reason is not in the whitelist
             * If the users' browser supports session storage they will be shown the retry link
             * in generic error page.
             */
            var fallbackNotWhitelisted = whitelist.indexOf(reason) === -1;

            // We can add countries to the config param to enable fallback to UX
            // If fallback reason not whitelisted
            if (fallbackNotWhitelisted) {
                _logger.$logger.info('fallback_reason_not_whitelisted', { reason: reason, product: product, country: country, paymentAction: paymentAction });

                // We're using sessionStorage for retry detection
                if (_squid.$util.sessionStorageEnabled()) {
                    var RETRY_KEY = 'retry_page_shown';
                    var RETRY_PAGE_LIMIT = 3; // Only show the retry page at most 3 times
                    var timesSeen = Number(sessionStorage.getItem(RETRY_KEY));
                    var destination = 'RETRY';

                    // Reset if there's an invalid value for timesSeen for some reason
                    if (!timesSeen || timesSeen < 0) {
                        timesSeen = 0;
                    }

                    // Only try to go to retry page if we're within retry attempts
                    if (timesSeen < RETRY_PAGE_LIMIT) {
                        timesSeen++;
                        sessionStorage.setItem(RETRY_KEY, timesSeen);
                    } else {
                        destination = 'DEFAULT';
                    }

                    _logger.$logger.info('checkout_fpti', {
                        'enable_refresh_prompt': reason
                    });

                    return goToGenericError(destination);
                }
                return goToGenericError();
            }

            _logger.$logger.info('fallback_reason_whitelisted', { reason: reason, product: product, country: country, paymentAction: paymentAction });

            if (_squid.$config.deploy.isLocal() && !entry_point) {
                return _angular.$log.info('Fallback inhibited in local mode. Please refresh to re-enable error logging');
            }

            _angular.$rootScope.$emit('loading');

            var urlParams = {
                token: _squid.$meta.token,
                fallback: 1,
                landing: entry_point,
                useraction: _squid.$util.param('useraction')
            };

            if (_angular.$rootScope.partnerIntegration) {
                urlParams.incontext = '1';
                urlParams.nolegacy = '1';
            } else if (_angular.$rootScope.miniBrowser) {
                urlParams.incontext = '1';
            }

            var _checkoutAppData$flag = checkoutAppData.flags,
                appDataFlags = _checkoutAppData$flag === undefined ? {} : _checkoutAppData$flag;

            var base = _squid.$config.urls.fallbackUrl[product];
            var wpsParams = void 0;

            if (checkoutAppData.is_wps_subscription_flow()) {
                base = _squid.$config.urls.fallbackUrl['wpsSubscription'];
                wpsParams = _squid.$util.decodeAndParse(_squid.$meta.xclickParams);
                wpsParams.cmd = wpsParams.hosted_button_id ? '_s-xclick' : '_xclick-subscriptions';
            } else if (checkoutAppData.isWpsAutobillingFlow()) {
                base = _squid.$config.urls.fallbackUrl['wpsSubscription'];
                wpsParams = _squid.$util.decodeAndParse(_squid.$meta.xclickParams);
                wpsParams.cmd = wpsParams.hosted_button_id ? '_s-xclick' : '_xclick-auto-billing';
            } else if (checkoutAppData.is_wps_flow()) {
                base = appDataFlags.is_cart_upload_flow || appDataFlags.is_shopping_cart_flow ? _squid.$config.urls.fallbackUrl['cartUpload'] : _squid.$config.urls.fallbackUrl['buyNow'];
                wpsParams = _squid.$util.decodeAndParse(_squid.$meta.xclickParams);
            }

            if (appDataFlags.is_invoice_flow) {
                urlParams.id = checkoutAppData.invoice_id;
                base = _squid.$config.urls.fallbackUrl['invoice'];
            }

            var hostname = _squid.$meta.stage ? _squid.$meta.stage : _angular.$window.location.hostname;
            var url = _squid.$util.buildURL('https://' + hostname + base, urlParams);

            if (checkoutAppData.is_wps_flow() || appDataFlags.is_invoice_flow) {
                goToUrl(url, wpsParams, checkoutAppData);
                return true;
            }

            if (product === 'ux') {
                var uxUrl = determineUrlForUxFallback(checkoutAppData, url);

                // Otherwise we can make a decision based on whether we're in the minibrowser or not
                return checkoutAppData.action('updateFallbackAction', {
                    data: {
                        fallback_action: 'CA_FALLBACK_USER_ACTION_LOGIN_GUEST_TAB_SELECTION'
                    },
                    success: function success() {
                        _index.$ReturnToMerchant.goTo(uxUrl);
                        return true;
                    },

                    contingencies: {
                        DEFAULT: function DEFAULT() {
                            _index.$ReturnToMerchant.goTo(uxUrl);
                            return true;
                        }
                    }
                })['catch'](function () {
                    _index.$ReturnToMerchant.goTo(uxUrl);
                    return true;
                });
            }

            // Safe to always return to Aries
            _squid.$util.redirect(url);
        }

        return goToGenericError();
    })['catch'](function (modelLoadErr) {
        _logger.$logger.info('fallback_model_load_error', { reason: modelLoadErr });
        return goToGenericError(modelLoadErr);
    });
}

angular.value("$fallbackErrorHandler", $fallbackErrorHandler);
_angular.$window;

_angular.$log;

_angular.$rootScope;

_uiRouter.$state;

_index.$ReturnToMerchant;

_squid.$FallbackError;

_squid.$config;

_squid.$meta;

_squid.$util;

_squid.$locale;

_squid.$populate;

_index2.$CheckoutInputDataModel;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutCartModel;

_index3.$CheckoutPayeeModel;

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ./js/lib/fallback.js
// module id = ./js/lib/fallback.js
// module chunks = 0